import { render, staticRenderFns } from "./shopify_export.vue?vue&type=template&id=58af6938&scoped=true&"
import script from "./shopify_export.vue?vue&type=script&lang=js&"
export * from "./shopify_export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58af6938",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58af6938')) {
      api.createRecord('58af6938', component.options)
    } else {
      api.reload('58af6938', component.options)
    }
    module.hot.accept("./shopify_export.vue?vue&type=template&id=58af6938&scoped=true&", function () {
      api.rerender('58af6938', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/shopify/shopify_export.vue"
export default component.exports